import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('life_benefits_set', '/life_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
